





































import { User } from 'oidc-client';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { ReportsApi, ReportStorage } from 'performo-api';

import Modal from '@/components/util/Modal.vue';

@Component({
  components: {
    Modal
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    api: 'reportsApi'
  })
})
export default class ReportPreview extends Vue {
  @Prop({ required: true })
  private queueId!: number;

  private currentPropertyId!: string;
  private currentUser!: User;
  private api!: ReportsApi;

  private loading = false;
  private modalShow = false;
  private wasProblem = false;
  private pdfDataUrl: string | null = null;

  private report?: ReportStorage = undefined;

  data() {
    return {
      loading: false,
      wasProblem: false,
      pdfDataUrl: null
    };
  }

  private get reportBlob() {
    if (this.report && this.report.reportData) {
      try {
        // convert our base64 pdf into a blob
        const byteCharacters = atob(this.report.reportData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
      } catch (error) {
        console.error('Error creating blob from report data:', error);
        this.wasProblem = true;
        return undefined;
      }
    }
    return undefined;
  }

  private closeModal() {
    this.modalShow = false;
    this.pdfDataUrl = null;
  }

  private async downloadHandler() {
    if (this.report && this.reportBlob) {
      try {
        const dataUrl = await this.blobToDataUrl(this.reportBlob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = dataUrl;
        a.download = 'performo-report.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error downloading report:', error);
        this.wasProblem = true;
      }
    }
  }

  private blobToDataUrl(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        if (fr.result && typeof fr.result === 'string') {
          resolve(fr.result);
        } else {
          reject(new Error('FileReader did not return a valid data URL'));
        }
      };
      fr.onerror = () => reject(fr.error);
      fr.readAsDataURL(blob);
    });
  }

  @Watch('modalShow')
  private async loadReportPreview(newModal: boolean) {
    if (!this.queueId || newModal !== true) return;

    // reset state
    this.loading = true;
    this.wasProblem = false;
    this.pdfDataUrl = null;

    try {
      // load the report
      this.report = await this.api.getReportByQueueId({
        queueId: this.queueId
      });

      // convert blob to data URL
      const blob = this.reportBlob;
      if (blob) {
        this.pdfDataUrl = await this.blobToDataUrl(blob);
      } else {
        throw new Error('Failed to create report blob');
      }
    } catch (error) {
      console.error('Error loading report:', error);
      this.wasProblem = true;
    } finally {
      this.loading = false;
    }
  }
}
